module.exports = require('./dist/inputs/sanitize');
